export default "__VITE_ASSET__DjGhQWGl__"